module.exports = __webpack_public_path__ + "static/media/22ESCWA2.eaf564a6.jpg";